<template>
    <div id="profile-page">
        <div class="page-heading">
            <h2 class="display-4 montserrat-bold mb-0">Points History</h2>
            <div class="mt--2 heading-small">Point Gain and Usage History</div>
        </div>
    
        <!-- <div class="search-bar-container">
            <i class="fas fa-search icon"></i>
            <input type="text" placeholder="Search" class="search-bar">
        </div> -->

        <div class="bg-white shadow-reg list-container">
            <div class="list-wrapper">
                <paginated-section :fetch-link="fetchLink" paginate-path="data.result.credit_points" ref="list" simplified>
                    <template slot="loading">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                            <i class="fas fa-spin fa-spinner mr-2"></i> Loading points history
                        </h3>
                    </template>
                    <template slot="empty">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">No records were found</h3>
                    </template>
                    <template slot="body" slot-scope="{ record }">
                        <point-list-item :point="record" />
                    </template>

                </paginated-section>
            </div>
        </div>

    </div>
</template> 
<script>
import '@styles/table.css';
import PointListItem from "./PointListItem";
import { route, get } from "@utils/network";

export default {
    name: "PointListPage",

    components: { PointListItem },

    computed: {
        fetchLink() {
            return route("customers/points");
        },
    },

    data: () => ({
        loading: false,
        points: [],
    }),

    methods: {
        setStatusFilter(status) {
            this.bookingParams.status = status;
            this.$refs.list.refresh();
        },
        isStatusActive(status) {
            return this.bookingParams.status == status;
        },
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>